
function keyEquals(key1, key2) {
    if (key1 == key2) {
        return true
    }

    if (key1 instanceof Array && key2 instanceof Array) {
        return key1.length == key2.length && key1.every((v, i)=> v == key2[i])
    }

    return false
}

export default function() {
    const cache = []

    return (key, build) => {
        var entry = cache.find((e) => keyEquals(e.key, key))

        if (!entry) {
            const value = build()
            entry = {key, value}
            cache.push(entry)
        }
        return entry.value
    }
}


// WEBPACK FOOTER //
// ./lib/core/cache.js